import React from "react";

export const TelevisionServiceConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes  : [
        //televisionService
        {
            path       : "/television/stats",
            component  : React.lazy(() => import("app/main/components/services/televisionService/televisionStats/showTelevisionStats/TelevisionStats")),
            permissions: ["manage_television_service"],
        },

        //apmax
        {
            path       : "/apmax/difference",
            component  : React.lazy(() => import("app/main/components/services/televisionService/apMax/apMaxDifference/ApmaxDifference")),
            permissions: ["manage_apmax"],
        },
        {
            path       : "/apmax/clients-brise",
            component  : React.lazy(() => import("app/main/components/services/televisionService/apMax/apMaxBrokenCustomer/BrokenCustomers")),
            permissions: ["manage_apmax"],
        },
        {
            path       : "/apmax",
            component  : React.lazy(() => import("app/main/components/services/televisionService/apMax/apMax/Apmax")),
            permissions: ["manage_apmax"],
        },

        //televisionBase
        {
            path       : "/bases/creer",
            component  : React.lazy(() => import("app/main/components/services/televisionService/base/CreateBase/CreateBase")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/bases/modifier/:id",
            component  : React.lazy(() => import("app/main/components/services/televisionService/base/updateBase/UpdateBase")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/bases",
            component  : React.lazy(() => import("app/main/components/services/televisionService/base/showBases/Bases")),
            permissions: ["manage_television_service"],
        },

        //newTelevisionBase
        {
            path       : "/nouvelles-bases/creer",
            component  : React.lazy(() => import("app/main/components/services/televisionService/newBase/CreateNewBase/CreateNewBasePage")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/nouvelles-bases/modifier/:id",
            component  : React.lazy(() => import("app/main/components/services/televisionService/newBase/updateNewBase/UpdateNewBasePage")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/nouvelles-bases",
            component  : React.lazy(() => import("app/main/components/services/televisionService/newBase/showNewBases/NewBases")),
            permissions: ["manage_television_service"],
        },

        //BrokenChannelLock
        {
            path       : "/barrure-brise",
            component  : React.lazy(() => import("app/main/components/services/televisionService/BrokenChannelLock/BrokenChannelLocks")),
            permissions: ["manage_broken_channel_lock"],
        },

        //channel
        {
            path       : "/chaines/creer",
            component  : React.lazy(() => import("app/main/components/services/televisionService/channel/createChannel/CreateChannel")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/chaines/modifier/:id",
            component  : React.lazy(() => import("app/main/components/services/televisionService/channel/updateChannel/UpdateChannel")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/chaines",
            component  : React.lazy(() => import("app/main/components/services/televisionService/channel/showChannels/Channels")),
            permissions: ["manage_television_service"],
        },

        //channel
        {
            path       : "/nouvelle-chaines/creer",
            component  : React.lazy(() => import("app/main/components/services/televisionService/newChannel/createNewChannel/CreateNewChannel")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/nouvelle-chaines/modifier/:id",
            component  : React.lazy(() => import("app/main/components/services/televisionService/newChannel/updateNewChannel/UpdateNewChannel")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/nouvelle-chaines",
            component  : React.lazy(() => import("app/main/components/services/televisionService/newChannel/showNewChannels/NewChannels")),
            permissions: ["manage_television_service"],
        },

        //channelPackage
        {
            path       : "/groupe-chaines/creer",
            component  : React.lazy(() => import("app/main/components/services/televisionService/channelPackage/CreateChannelPackage/CreateChannelPackage")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/groupe-chaines/modifier/:id",
            component  : React.lazy(() => import("app/main/components/services/televisionService/channelPackage/updateChannelPackage/UpdateChannelPackage")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/groupe-chaines",
            component  : React.lazy(() => import("app/main/components/services/televisionService/channelPackage/ShowChannelPackages/ChannelPackages")),
            permissions: ["manage_television_service"],
        },

        //newChannelPackage
        {
            path       : "/nouveau-groupe-chaines/modifier/:id",
            component  : React.lazy(() => import("app/main/components/services/televisionService/newChannelPackage/updateNewChannelPackage/UpdateNewChannelPackagePage")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/nouveau-groupe-chaines/creer",
            component  : React.lazy(() => import("app/main/components/services/televisionService/newChannelPackage/CreateNewChannelPackage/CreateNewChannelPackagePage")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/nouveau-groupe-chaines",
            component  : React.lazy(() => import("app/main/components/services/televisionService/newChannelPackage/ShowNewChannelPackages/NewChannelPackages")),
            permissions: ["manage_television_service"],
        },


        //commercialPackage
        {
            path       : "/groupe-commercials/creer",
            component  : React.lazy(() => import("app/main/components/services/televisionService/commercialPackage/CreateCommercialPackage/CreateCommercialPackage")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/groupe-commercials/modifier/:id",
            component  : React.lazy(() => import("app/main/components/services/televisionService/commercialPackage/updateCommercialPackage/UpdateCommercialPackage")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/groupe-commercials",
            component  : React.lazy(() => import("app/main/components/services/televisionService/commercialPackage/ShowCommercialPackages/CommercialPackagesList")),
            permissions: ["manage_television_service"],
        },

        //megaChannelPackage
        {
            path       : "/mega-groupe-chaines/creer",
            component  : React.lazy(() => import("app/main/components/services/televisionService/megaChannelPackage/createChannelPackage/CreateMegaChannelPackage")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/mega-groupe-chaines/modifier/:id",
            component  : React.lazy(() => import("app/main/components/services/televisionService/megaChannelPackage/updateMegaChannelPackage/UpdateMegaChannelPackage")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/mega-groupe-chaines",
            component  : React.lazy(() => import("app/main/components/services/televisionService/megaChannelPackage/showMegaChannelPackages/MegaChannelPackages")),
            permissions: ["manage_television_service"],
        },

        //pickAndPackOption
        {
            path       : "/option-sur-mesures/creer",
            component  : React.lazy(() => import("app/main/components/services/televisionService/pickAndPackOption/createPickAndPackOption/CreatePickAndPackOption")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/option-sur-mesures/modifier/:id",
            component  : React.lazy(() => import("app/main/components/services/televisionService/pickAndPackOption/updatePickAndPackOption/UpdatePickAndPackOption")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/option-sur-mesures",
            component  : React.lazy(() => import("app/main/components/services/televisionService/pickAndPackOption/showPickAndPackOptions/PickAndPackOptions")),
            permissions: ["manage_television_service"],
        },

        //pickAndPackType
        {
            path       : "/sur-mesures/creer",
            component  : React.lazy(() => import("app/main/components/services/televisionService/pickAndPackType/createPickAndPackType/CreatePickAndPackTypes")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/sur-mesures/modifier/:id",
            component  : React.lazy(() => import("app/main/components/services/televisionService/pickAndPackType/updatePickAndPakcType/UpdatePickAndPackType")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/sur-mesures",
            component  : React.lazy(() => import("app/main/components/services/televisionService/pickAndPackType/showPickAndPackTypes/PickAndPackTypes")),
            permissions: ["manage_television_service"],
        },

        //optionsEnregistrement
        {
            path       : "/television/options-enregistrement",
            component  : React.lazy(() => import("app/main/components/services/televisionService/tvRecordingOption/TVRecordingOptions")),
            permissions: ["manage_television_service"],
        },

        //optionsFlux
        {
            path       : "/television/options-flux",
            component  : React.lazy(() => import("app/main/components/services/televisionService/tvStreamOption/TVStreamOptions")),
            permissions: ["manage_television_service"],
        },

        //regions
        {
            path       : "/television/regions",
            component  : React.lazy(() => import("app/main/components/services/televisionService/region/Regions")),
            permissions: ["manage_television_service"],
        },
        //newPickAndPackType
        {
            path       : "/nouveau-type-sur-mesures/creer",
            component  : React.lazy(() => import("app/main/components/services/televisionService/newPickAndPackType/createNewPickAndPackType/CreateNewPickAndPackTypes")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/nouveau-type-sur-mesures/modifier/:id",
            component  : React.lazy(() => import("app/main/components/services/televisionService/newPickAndPackType/updateNewPickAndPackType/UpdateNewPickAndPackTypes")),
            permissions: ["manage_television_service"],
        },
        {
            path       : "/nouveau-type-sur-mesures",
            component  : React.lazy(() => import("app/main/components/services/televisionService/newPickAndPackType/showNewPickAndPackTypes/NewPickAndPackTypes")),
            permissions: ["manage_television_service"],
        },
    ],
};